export default "__VITE_ASSET__DBqhOVs8__"